import { Booking } from '../types/booking'
import {
  CardKeyRequest,
  IdentityCardRequest,
  IdentityInfo,
  ReservationLoginRequest,
  ReservationLoginResponse,
} from '../types/checkinTypes'
import authClient from './authClient'
import httpClient from './httpClient'

export const getCheckInReservation = (hotelId: number | string, reservationId: number | string): Promise<Booking> => {
  return authClient.get(`/checkin/${hotelId}/reservation/${reservationId}`)
}

export const requestCardKey = (
  hotelId: number | string,
  reservationId: number | string,
  req: CardKeyRequest,
): Promise<void> => {
  return authClient.post(`/checkin/${hotelId}/reservation/${reservationId}/cardkey`, req)
}

export const scanIdentityCard = (
  hotelId: number | string,
  reservationId: number | string,
  req: IdentityCardRequest,
): Promise<IdentityInfo> => {
  return authClient.post(`/checkin/${hotelId}/reservation/${reservationId}/scan`, req)
}

export const validateIdentityCard = (
  hotelId: number | string,
  reservationId: number | string,
  req: IdentityCardRequest,
): Promise<IdentityInfo> => {
  return authClient.post(`/checkin/${hotelId}/reservation/${reservationId}/validatescan`, req)
}

export const reservationLogin = (
  hotelId: number | string,
  request: ReservationLoginRequest,
): Promise<ReservationLoginResponse> => {
  return httpClient.post(`/checkin/${hotelId}/login`, request)
}

export const checkin = (
  hotelId: number | string,
  reservationId: number | string,
): Promise<ReservationLoginResponse> => {
  return authClient.post(`/checkin/${hotelId}/reservation/${reservationId}/checkin`)
}
